import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FileImport"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21 14.25H11.1225L13.0575 12.3075L12 11.25L8.25 15L12 18.75L13.0575 17.6925L11.1225 15.75H21V14.25ZM18 7.50001V10.5H16.5V9.00001H12C11.1716 9.00001 10.5 8.32844 10.5 7.50001V3.00001H4.5V21H16.5V19.5H18V21C18 21.8284 17.3284 22.5 16.5 22.5H4.5C3.67157 22.5 3 21.8284 3 21V3.00001C3 2.17159 3.67157 1.50001 4.5 1.50001H12C12.1994 1.49886 12.391 1.57712 12.5325 1.71751L17.7825 6.96751C17.9229 7.10905 18.0012 7.30066 18 7.50001ZM12 3.30754V7.50004H16.1925L12 3.30754Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FileImport.vue"]]);
